import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className }) => (
  <span
    className={cn(
      "inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-[#00F0FF]",
      className
    )}
  >
    <span className="h-1.5 w-1.5 rounded-full bg-[#00F0FF] pv-live-dot" />
    {children}
  </span>
);

export const PrimaryButton = ({ children, className, ...props }) => (
  <button
    className={cn(
      "group inline-flex items-center justify-center gap-2 rounded-full bg-[#00F0FF] px-7 py-3.5 text-sm font-bold text-[#0C1120] transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-0.5 hover:bg-white hover:shadow-[0_0_35px_rgba(0,240,255,0.55)] focus:outline-none focus:ring-2 focus:ring-[#00F0FF] focus:ring-offset-2 focus:ring-offset-[#0C1120]",
      className
    )}
    {...props}
  >
    {children}
  </button>
);

export const GhostButton = ({ children, className, ...props }) => (
  <button
    className={cn(
      "inline-flex items-center justify-center gap-2 rounded-full border border-white/20 bg-white/[0.02] px-7 py-3.5 text-sm font-semibold text-white transition-[transform,border-color,background-color] duration-300 hover:-translate-y-0.5 hover:border-[#00F0FF]/60 hover:bg-white/[0.06] focus:outline-none focus:ring-2 focus:ring-[#00F0FF]",
      className
    )}
    {...props}
  >
    {children}
  </button>
);

export const SectionHeader = ({ overline, title, sub, className }) => (
  <div className={cn("max-w-3xl", className)}>
    <Reveal>
      <Overline>{overline}</Overline>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-5 text-4xl font-semibold tracking-tight sm:text-5xl">
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className="mt-5 text-base leading-relaxed text-slate-400 sm:text-lg">
          {sub}
        </p>
      </Reveal>
    )}
  </div>
);
